import { type ReactNode } from 'react'

interface FormSectionProps {
  title: string
  children: ReactNode
}

function FormSection({ title, children }: FormSectionProps) {
  return (
    <section className="mb-6">
      <h4 className="mb-4 text-base font-medium text-gray-800">{title}</h4>
      <div className="grid grid-cols-1 gap-x-6 gap-y-1 md:grid-cols-2">{children}</div>
    </section>
  )
}

export default FormSection
